<div class="wiz-box">
  <div class="heading">{{'wizard.step-2.title' | translate}}</div>
  <div class="wiz-content row">
    <p class="my-2 mb-4">{{'wizard.step-2.p-1' | translate}}</p>
    <div class="mt-1 d-flex w-100">
      <ng-container *ngTemplateOutlet="template;context:{ctx:{formGroup: depotsGroup, type:'depots', map: depotMap }};">
      </ng-container>
      <ng-container *ngTemplateOutlet="template;context:{ctx:{formGroup: checkoutsGroup, type: 'checkouts', map: checkoutMap}};">
      </ng-container>
    </div>
  </div>
  <div class="wiz-footer">
    <button class="secondary-btn" routerLink="/plugplay/step-1"><i
        class="fas fa-chevron-left"></i><span>{{'wizard.step-2.btn-back' | translate}}</span></button>
    <button class="primary-btn" routerLink="/plugplay/step-3/list"
      (click)="setHighestLastStepCompleted.emit(1)"><span>{{'wizard.step-2.btn-continue' | translate}}</span><i
        class="fas fa-chevron-right"></i>
    </button>
  </div>
</div>


<ng-template #template let-ctx="ctx">
  <div class="col" [formGroup]="ctx.formGroup">
    <div class="subtitle">{{'wizard.step-2.subtitle.'+ctx.type | translate}}</div>
    <ng-container *ngFor="let item of ctx.formGroup?.controls | keyvalue: order;trackBy: trackById; let last = last, let index = index">
      <form-row-input
        [appendBtnIcon]="ctx.map.get(+item.key)?.id > 0 && ctx.map.get(+item.key)?.deletable && (!last || item.key.includes('new')) && !last? 'fa-times-circle': null"
        (onAppendBtnEvent)="last ? null : deleteDialog(item.key, ctx.type)"
        formControlName="{{item.key}}"
        (modelChange)="addItem(ctx.formGroup)"
        (focusout)="save(item.key, ctx.type)"
        [placeholder]="'wizard.step-2.placeholder.'+ctx.type"
        [disallowTabNavToBtn]="true">
      </form-row-input>
    </ng-container>
  </div>
</ng-template>
